export default __webpack_public_path__ + "static/media/disconnected.b7320dfc.svg";